import React, {useCallback, useEffect, useState} from 'react';

import {
  Container,
  LocationList,
  LocationPill,
  LocationContainer,
  LocationPillText,
  Icon,
  ModalOverlay,
  ModalContainer,
  ModalIconContainer,
  ModalTitle,
  ModalDescription,
  ModalButtonsContainer,
} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';
import {Step} from '../../Interface/Step';
import {useTheme} from 'styled-components/native';
import {useLocalization} from '../../../context/localization';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Modal, Linking, Platform, TouchableWithoutFeedback} from 'react-native';
import {Button} from '../../Interface/Forms/Buttons/Button';

interface Props {
  cidade?: string;
  tipo: string;
  onPressUserLocationCallback?: () => void;
}

export function LocationPillContainer({
  cidade,
  tipo,
  onPressUserLocationCallback,
}: Props) {
  const {locationIsActive, geolocation, refreshLocation} = useLocalization();
  const theme = useTheme();
  const navigation = useNavigation();
  const route = useRoute();
  const [showLocationModal, setShowLocationModal] = useState(false);

  // Fecha o modal automaticamente quando a localização é ativada
  useEffect(() => {
    if (locationIsActive && showLocationModal) {
      setShowLocationModal(false);
      navigation.setParams({
        ...route.params,
        tipo: tipo,
        cidade: undefined,
        localidade: undefined,
        isUserLocation: true,
        refresh: true,
      });
      onPressUserLocationCallback?.();
    }
  }, [locationIsActive]);

  const navigateToLocalization = useCallback(() => {
    navigation.navigate('Localization', {
      tipo,
    });
  }, [tipo]);

  const onPressUserLocation = useCallback(() => {
    if (locationIsActive) {
      navigation.setParams({
        ...route.params,
        tipo: tipo,
        cidade: undefined,
        localidade: undefined,
        isUserLocation: true,
        refresh: true,
      });
      onPressUserLocationCallback?.();
    } else {
      setShowLocationModal(true);
    }
  }, [locationIsActive, geolocation, navigateToLocalization, onPressUserLocationCallback]);

  const handleCloseModal = useCallback(() => {
    setShowLocationModal(false);
  }, []);

  const handleOpenSettings = useCallback(() => {
    if (Platform.OS === 'ios') {
      Linking.openURL('app-settings:');
    } else {
      Linking.openSettings();
    }
  }, []);

  const handleVerifyAndSelect = useCallback(() => {
    setShowLocationModal(false);
    refreshLocation();
    navigation.setParams({
      ...route.params,
      tipo: tipo,
      cidade: undefined,
      localidade: undefined,
      isUserLocation: true,
      refresh: true,
    });
    onPressUserLocationCallback?.();
  }, [refreshLocation, navigation, route.params, tipo, onPressUserLocationCallback]);

  return (
    <Container>
      <Modal
        visible={showLocationModal}
        transparent
        animationType="fade"
        onRequestClose={handleCloseModal}>
        <TouchableWithoutFeedback onPress={handleCloseModal}>
          <ModalOverlay>
            <TouchableWithoutFeedback>
              <ModalContainer>
            <ModalIconContainer>
              <Icon
                name="map-pin"
                size={40}
                color={theme.colors.blue}
              />
            </ModalIconContainer>
            <ModalTitle>Localização desativada</ModalTitle>
            <ModalDescription>
              Para usar sua localização atual, ative a permissão de localização nas configurações do seu dispositivo.
            </ModalDescription>
            <ModalButtonsContainer>
              <Button
                title="Abrir configurações"
                color={theme.colors.blue}
                onPress={handleOpenSettings}
                enabled
              />
              <Button
                title="Já ativei"
                color={theme.colors.blue}
                onPress={handleVerifyAndSelect}
                enabled
                variant="outline"
                mt={12}
              />
            </ModalButtonsContainer>
              </ModalContainer>
            </TouchableWithoutFeedback>
          </ModalOverlay>
        </TouchableWithoutFeedback>
      </Modal>
      <Step
        order={6}
        contextName="welcome"
        customStyle={{
          marginTop: RFValue(10),
        }}
        text="Aqui você pode optar por buscar postos pela sua localização atual ou selecionar manualmente.">
        <LocationList>
          <LocationContainer>
            <LocationPill selected={!cidade} onPress={onPressUserLocation}>
              <LocationPillText selected={!cidade}>
                Minha localização
              </LocationPillText>
              <Icon
                name="map-pin"
                size={16}
                color={
                  !cidade
                    ? theme.colors.purple_2_shadow_white
                    : theme.colors.title
                }
              />
            </LocationPill>

            <LocationPill
              selected={!!cidade}
              onPress={navigateToLocalization}>
              <LocationPillText selected={!!cidade}>
                {cidade
                  ? cidade.length > 14
                    ? cidade.slice(0, 14) + '...'
                    : cidade
                  : 'Outra localização'}
              </LocationPillText>
              <Icon
                name="chevron-right"
                size={20}
                color={
                  cidade
                    ? theme.colors.purple_2_shadow_white
                    : theme.colors.title
                }
              />
            </LocationPill>
          </LocationContainer>
        </LocationList>
      </Step>
    </Container>
  );
}
